module.exports = __webpack_public_path__ + "static/media/new_back_3.3033c45c.png";